import React from 'react';

const DEFAULT_STYLE = { background: '#2550AC', color: 'white', fontSize: '9px', padding: '0px 3px', borderRadius: '2px' };

const AutoTimeRecordingBadge = ({ title, style, wrapperStyle }) => (
    <span title={'Auto time recording'} style={wrapperStyle}>
        <span style={{ ...DEFAULT_STYLE, ...style }}>A</span>
    </span>
);

export default AutoTimeRecordingBadge;
